<template>
  <div class="echars">
    <div id="echarth-anquan"></div>
  </div>
</template>

<script>
export default {
  name: "echarth-anquan",
  props:["title"],
  data() {
    return {
      value1: {}
    }
  },
  watch: {
    title: function (newData) {
      this.value1 = newData
      let data = []
      let name = ''
      for(let key in this.value1[0]){
      if(key==="unpassCount"){
        data.push({ value: this.value1[0][key], name: "未通过" })
      }else if(key==="lateCount"){
        data.push({ value: this.value1[0][key], name: "未参加" })
      }else if(key==="passCount"){
        data.push({ value: this.value1[0][key], name: "通过" })
      }else if(key==="total"){
        name=`共计\n${this.value1[0][key]}人`
      }
      }
      this.mapFn(data,name)
    }
  },
  methods: {
    mapFn(data,name) {
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(
        document.getElementById("echarth-anquan")
      );
      document
        .getElementById("echarth-xueli")
        .removeAttribute("_echarts_instance_");
      mapChart.setOption({
        title: {
        text: name,
        top: 115,
        left: 'center',
        textStyle: {
          color: '#333333',
          fontSize: '24',
        },
      },
        color: ["#0b41eb", "#34A1F7", "#B4D5F1"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "5%",
          left: "25%",
        },
        series: [
          {
            center:['50%','43%'],
            type: "pie",
            radius: ["60%", "80%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "inner",
              formatter: "{d}%",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data
          },
        ],
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
    },
  },
  mounted() {
    this.mapFn();
  },
};
</script>
<style scoped>
.echars {
  width: 23vw;
  height: 35vh;
}
#echarth-anquan {
  width: 23vw;
  height: 35vh;
}
</style>
